import React from "react";
import { T } from "services/lang/LanguageService";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import { DropdownChangeEvent } from "primereact/dropdown";
import { DatasetLoadingConf } from "./interfaces";

interface LoadConfigInputsProps {
  loadConf: DatasetLoadingConf;
  handleLoadConfChange: (e: DatasetLoadingConf) => void;
}

export const DefaultDatasetLoadingConf: DatasetLoadingConf = {
  lead: 0,
  lag: 3,
  lagUnit: "HOURS",
  leadUnit: "HOURS",
  alignUnit: "MINUTES",
};

const LoadConfigInputs = (props: LoadConfigInputsProps) => {
  const handleLoadConfChange = (e: InputNumberValueChangeEvent | DropdownChangeEvent) => {
    const key = e.target.id as keyof DatasetLoadingConf;
    let { value } = e.target;
    if (typeof value === "object" && value._name) {
      value = value._name.toUpperCase();
    } else if (Number.isNaN(value)) {
      value = value.toString().toUpperCase();
    }
    const currentLoadConfig = { ...props.loadConf, [key]: value };

    props.handleLoadConfChange(currentLoadConfig);
  };

  return (
    <>
      <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
        <label htmlFor="lag">{T("load-conf.lag")}</label>
        <div className="p-inputgroup">
          <InputNumber
            id="lag"
            className="w-6"
            value={props.loadConf.lag as number}
            onValueChange={handleLoadConfChange}
          />
          <TimeUnitDropdown
            id="lagUnit"
            className="p-inputgroup-addon p-0 w-6"
            value={props.loadConf.lagUnit}
            onChange={handleLoadConfChange}
          />
        </div>
      </div>
      <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
        <label htmlFor="lead">{T("load-conf.lead")}</label>
        <div className="p-inputgroup">
          <InputNumber
            id="lead"
            className="w-6"
            value={props.loadConf.lead as number}
            onValueChange={handleLoadConfChange}
          />
          <TimeUnitDropdown
            id="leadUnit"
            className="p-inputgroup-addon p-0 w-6"
            value={props.loadConf.leadUnit}
            onChange={handleLoadConfChange}
          />
        </div>
      </div>
      <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
        <label htmlFor="alignUnit">{T("load-conf.align-unit")}</label>
        <TimeUnitDropdown
          id="alignUnit"
          className="w-full"
          value={props.loadConf.alignUnit ? props.loadConf.alignUnit : ""}
          onChange={handleLoadConfChange}
        />
      </div>
    </>
  );
};

export default LoadConfigInputs;
